import { Chip, IconButton, Paper, TextField, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { isArray, isString } from "lodash";
import toastError from "../../errors/toastError";
import { dedupeTagsById } from "../../helpers/normalizeContactTags";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import AddIcon from "@material-ui/icons/Add";
import LabelIcon from "@material-ui/icons/Label";

export function TagsContainer({ contact }) {
	const theme = useTheme();
	const [tags, setTags] = useState([]);
	const [selecteds, setSelecteds] = useState([]);
	const [inputValue, setInputValue] = useState("");
	const contactId = contact?.id;

	useEffect(() => {
		let cancelled = false;
		async function fetchData() {
			try {
				const { data } = await api.get("/tags/list");
				if (cancelled) return;
				setTags(Array.isArray(data) ? data : []);
				setSelecteds(dedupeTagsById(contact?.tags || []));
			} catch (err) {
				if (!cancelled) toastError(err);
			}
		}
		setSelecteds(dedupeTagsById(contact?.tags || []));
		fetchData();
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contactId]);

	useEffect(() => {
		setSelecteds(dedupeTagsById(contact?.tags || []));
	}, [contactId, contact?.tags]);

	const createTag = async (data) => {
		try {
			const { data: responseData } = await api.post("/tags", data);
			return responseData;
		} catch (err) {
			toastError(err);
		}
	};

	const loadTags = async () => {
		try {
			const { data } = await api.get("/tags/list");
			setTags(Array.isArray(data) ? data : []);
			setSelecteds(dedupeTagsById(contact?.tags || []));
		} catch (err) {
			toastError(err);
		}
	};

	const syncTags = async (data) => {
		try {
			const { data: responseData } = await api.post("/tags/sync", data);
			return responseData;
		} catch (err) {
			toastError(err);
		}
	};

	const uniqueTagsList = () => {
		const filteredTags = tags?.filter((tag) => {
			const found = selecteds.find((selected) => selected.id === tag.id);
			return !found;
		});

		return filteredTags;
	};

	const onChange = async (value, reason) => {
		let optionsChanged = [];

		if (reason === "create-option") {
			for (const item of value) {
				if (isString(item.name)) {
					const newTag = await createTag({
						name: item.name,
						contactId: contact.id,
					});
					optionsChanged.push(newTag);
				} else {
					optionsChanged.push(item);
				}
			}
			await loadTags();
		} else {
			optionsChanged = value;
		}

		const unique = dedupeTagsById(optionsChanged.filter(Boolean));
		setSelecteds(unique);
		await syncTags({ contactId: contact.id, tags: unique });
	};

	const [adding, setAdding] = useState(false);

	return (
		<Paper
			elevation={0}
			style={{
				background:
					theme.palette.type === "dark"
						? "rgba(255, 255, 255, 0.04)"
						: "#fff",
				color: theme.palette.text.primary,
				maxWidth: 420,
				borderRadius: "none",
				borderTop: `1px solid ${theme.palette.divider}`,
				borderBottom: `1px solid ${theme.palette.divider}`,
				padding: "25px 10px",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					marginBottom: 8
				}}
			>
				<LabelIcon style={{ fontSize: 18, marginRight: 6 }} />
				<Typography
					variant="subtitle2"
					style={{ flex: 1, color: theme.palette.text.primary }}
				>
					Etiquetas
				</Typography>

				<IconButton size="small" onClick={() => setAdding(true)}>
					<AddIcon fontSize="small" />
				</IconButton>
			</div>

			<div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
				{selecteds.map((tag, index) => (
					<Chip
						key={tag.id != null ? tag.id : `tag-${index}`}
						size="small"
						clickable
						label={tag.name}
						onClick={() => {
							const updated = selecteds.filter((_, i) => i !== index);
							onChange(updated, "remove");
						}}
						style={{
							backgroundColor: tag.color || "#e0e0e0",
							color: "#fff",
							fontWeight: 500,
							cursor: "pointer"
						}}
					/>
				))}
			</div>

			{adding && (
				<div style={{ marginTop: 8 }}>
					<Autocomplete
						size="small"
						freeSolo
						options={uniqueTagsList()}
						inputValue={inputValue}
						onInputChange={(e, value) => setInputValue(value)}
						filterOptions={(options, { inputValue }) =>
							options.filter((option) =>
								option.name.toLowerCase().includes(inputValue.toLowerCase())
							)
						}
						getOptionLabel={(option) =>
							typeof option === "string" ? option : option.name
						}
						onChange={(e, v, reason) => {
							if (!v) return;

							if (reason === "create-option") {
								onChange([...selecteds, { name: v }], "create-option");
							}

							if (reason === "select-option") {
								onChange([...selecteds, v], "select-option");
							}

							setInputValue("");
							setAdding(false);
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								autoFocus
								variant="outlined"
								placeholder="Adicionar etiqueta"
								InputProps={{
									...params.InputProps,
									style: { borderRadius: 10 }
								}}
							/>
						)}
					/>

				</div>

			)}
		</Paper>
	);
}
